module.exports = __webpack_public_path__ + "static/media/bar_chart_up.b01bd0ab.svg";